import {createSlice} from '@reduxjs/toolkit';

const getStoredPermissions = () => {
    try {
        const parsed = JSON.parse(localStorage.getItem('activePermissions') || '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
};

const initialState = {
    isLogin: false,
    activeUserName: '',
    activeUserRole: localStorage.getItem('activeUserRole') || 'USER', // 'USER' or 'ADMIN' (company admin flag)
    activeAccessRoleId: localStorage.getItem('activeAccessRoleId') || null,
    activeAccessRoleName: localStorage.getItem('activeAccessRoleName') || '',
    activePermissions: getStoredPermissions(),
    activeCompanyLogoURL: '',
    activeCompanyDetails: null, // { company_name, locality, street, place, city, state, post_code } from company details table
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLogin(state) {
            state.isLogin = true;
        },
        setLogout(state) {
            state.isLogin = false;
            state.activeUserName = '';
            state.activeUserRole = 'USER';
            state.activeAccessRoleId = null;
            state.activeAccessRoleName = '';
            state.activePermissions = [];
            state.activeCompanyLogoURL = '';
            state.activeCompanyDetails = null;
            localStorage.removeItem('activeUserRole');
            localStorage.removeItem('activeAccessRoleId');
            localStorage.removeItem('activeAccessRoleName');
            localStorage.removeItem('activePermissions');
        },
        setActiveUserName(state, action) {
            state.activeUserName = action.payload;
        },
        setActiveUserRole(state, action) {
            state.activeUserRole = action.payload || 'USER';
        },
        setActiveAccess(state, action) {
            const payload = action.payload || {};
            state.activeAccessRoleId = payload.accessRoleId ?? null;
            state.activeAccessRoleName = payload.accessRoleName || '';
            state.activePermissions = Array.isArray(payload.permissions) ? payload.permissions : [];
            if (payload.accessRoleId != null) localStorage.setItem('activeAccessRoleId', String(payload.accessRoleId));
            else localStorage.removeItem('activeAccessRoleId');
            localStorage.setItem('activeAccessRoleName', state.activeAccessRoleName);
            localStorage.setItem('activePermissions', JSON.stringify(state.activePermissions));
        },
        setActiveCompanyLogoURL(state, action) {
            state.activeCompanyLogoURL = action.payload;
        },
        clearCompanyLogo(state) {
            state.activeCompanyLogoURL = '';
            // Note: We intentionally don't clear activeUserName here
            // to ensure username persists even when logo is cleared
        },
        setActiveCompanyDetails(state, action) {
            state.activeCompanyDetails = action.payload;
        }
    }
});

export const authActions = authSlice.actions;
export default authSlice;
